const baseDetail = require('base/product/detail');
const base = require('./base');

module.exports = Object.assign(baseDetail, {
  availability: base.availability,

  addToCart: base.addToCart,

  updateAttributesAndDetails() {
    $('body').on('product:statusUpdate', (e, data) => {
      const $productContainer = $(`.product-detail[data-pid="${data.id}"]`);

      $productContainer
        .find('.description-and-detail .product-attributes')
        .empty()
        .html(data.attributesHtml);

      if (data.shortDescription) {
        $productContainer
          .find('.description-and-detail .description')
          .removeClass('hidden-xl-down');
        $productContainer
          .find('.description-and-detail .description .content')
          .empty()
          .html(data.shortDescription);
      } else {
        $productContainer
          .find('.description-and-detail .description')
          .addClass('hidden-xl-down');
      }

      if (data.longDescription) {
        $productContainer
          .find('.description-and-detail .details')
          .removeClass('hidden-xl-down');
        $productContainer
          .find('.description-and-detail .details .content')
          .empty()
          .html(data.longDescription);
      } else {
        $productContainer
          .find('.description-and-detail .details')
          .addClass('hidden-xl-down');
      }
    });
  },

  showSpinner() {
    $('body').on(
      'product:beforeAddToCart product:beforeAttributeSelect',
      () => {
        $.spinner().start();
      }
    );
  },
  updateAttribute() {
    $('body').on('product:afterAttributeSelect', (e, response) => {
      if ($('.product-detail>.bundle-items').length) {
        response.container.data('pid', response.data.product.id);
        response.container.find('.product-id').text(response.data.product.id);
      } else if ($('.product-set-detail').eq(0)) {
        response.container.data('pid', response.data.product.id);
        response.container.find('.product-id').text(response.data.product.id);
      } else {
        response.container.find('.product-id').text(response.data.product.id);
        response.container
          .find('.product-detail:not(".bundle-item")')
          .data('pid', response.data.product.id);
      }
    });
  },
  updateAddToCart() {
    $('body').on('product:updateAddToCart', (e, response) => {
      // update local add to cart (for sets)
      $('button.add-to-cart', response.$productContainer).attr(
        'disabled',
        !response.product.readyToOrder || !response.product.available
      );

      const enable = $('.product-availability')
        .toArray()
        .every(
          (item) => $(item).data('available') && $(item).data('ready-to-order')
        );
      baseDetail.methods.updateAddToCartEnableDisableOtherElements(!enable);
    });
  },
  updateAvailability() {
    $('body').on('product:updateAvailability', (e, response) => {
      $('div.availability', response.$productContainer)
        .data('ready-to-order', response.product.readyToOrder)
        .data('available', response.product.available);

      $('.availability-msg', response.$productContainer)
        .empty()
        .html(response.message);

      if ($('.global-availability').length) {
        const allAvailable = $('.product-availability')
          .toArray()
          .every((item) => $(item).data('available'));

        const allReady = $('.product-availability')
          .toArray()
          .every((item) => $(item).data('ready-to-order'));

        $('.global-availability')
          .data('ready-to-order', allReady)
          .data('available', allAvailable);

        $('.global-availability .availability-msg')
          .empty()
          .html(
            allReady ? response.message : response.resources.info_selectforstock
          );
      }
    });
  },
  sizeChart() {
    $('.size-chart a').on('click', function sizeChartClick(e) {
      e.preventDefault();
      const url = $(this).attr('href');
      const $prodSizeChart = $(this)
        .closest('.size-chart')
        .find('.size-chart-collapsible');
      if ($prodSizeChart.is(':empty')) {
        $.ajax({
          url,
          type: 'get',
          dataType: 'json',
          success(data) {
            $prodSizeChart.append(data.content);
          },
        });
      }
      $prodSizeChart.toggleClass('active');
    });

    const $sizeChart = $('.size-chart-collapsible');
    $('body').on('click touchstart', (e) => {
      if ($('.size-chart').has(e.target).length <= 0) {
        $sizeChart.removeClass('active');
      }
    });
  },
  copyProductLink() {
    $('body').on('click', '#fa-link', (event) => {
      event.preventDefault();
      const $temp = $('<input>');
      $('body').append($temp);
      $temp.val($('#shareUrl').val()).select();
      document.execCommand('copy');
      $temp.remove();
      $('.copy-link-message').attr('role', 'alert');
      $('.copy-link-message').removeClass('d-none');
      setTimeout(() => {
        $('.copy-link-message').addClass('d-none');
      }, 3000);
    });
  },

  /* ByL custom method */
  updateStockAlertSection() {
    $('.show-alertstock-popup').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      $('.product-stock-alert-signup').addClass('show');
    });

    $('.product-stock-alert-signup').on('click', () => {
      $('.product-stock-alert-signup').removeClass('show');
    });

    $('.product-stock-alert-signup .container').on('click', (e) => {
      e.stopPropagation();
    });
  },

  /* ByL custom method */
  subscribeAlertStockButton() {
    function displayMessage(data, button) {
      $.spinner().stop();
      button.removeAttr('disabled');
    }

    $('button.stockalert-subscribe-email').on(
      'click',
      function stockAlertSubscribeClick(e) {
        e.preventDefault();
        const url = $(this).data('href');
        const button = $(this);
        const email = $('input[name=psAlertSignUp_email]').val();
        const pid = $('button.add-to-cart').attr('data-pid');
        const sizeId = $('input[name=psAlertSignUp_size]:checked').val();
        $.spinner().start();
        $(this).attr('disabled', true);
        $.ajax({
          url,
          type: 'post',
          dataType: 'json',
          data: {
            email,
            pid,
            size_id: sizeId,
          },
          success(data) {
            displayMessage(data, button);
          },
          error(err) {
            displayMessage(err, button);
          },
        });
      }
    );
  },

  focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
});
